export default (that) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.batch_label_orderBatchNo') || '交货批次号',
    field: 'orderBatchNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_identifyNo') || '批次识别单号',
    field: 'identifyNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_deliveryDate') || '出货日期',
    field: 'deliveryDate',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_outBillType') || '出单类型',
    field: 'outBillType',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_dispatchPort') || '发运港口',
    field: 'dispatchPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.batch_label_destinationPort') || '目的港口',
    field: 'destinationPort',
    headerAlign: 'center',
    align: 'center',
    width: 130,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
